<template>
    <v-row no-gutters>
        <v-col cols="12">
            <!-- <v-row justify="start" class="mt-2 mx-4">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                <p class="text-caption text-start">
                    <router-link :to="{ name: 'user-dashboard' }">Dashboard</router-link> &gt;
                    <router-link :to="{ name: 'user-organization-list' }">Organizations</router-link>
                    <template v-if="organization">
                    &gt; <router-link :to="{ name: 'organization-dashboard', params: { realm: this.$route.params.organizationId } }">{{ organization.name }}</router-link>
                    </template>
                </p>
                </v-col>
            </v-row> -->
            <!-- <v-row justify="center" class="py-5 mt-2">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                <h1 class="text-h6 font-weight-light text-center">Dynamic DNS records</h1>
                </v-col>
            </v-row> -->
            <!-- <v-row justify="center" class="py-5">
                <v-col style="text-align: center" cols="12" sm="6">
                    <v-textarea :value="tinydnsconfig"></v-textarea>
                </v-col>
            </v-row> -->
            <v-row justify="center" class="py-5 px-10 mb-8 mt-2">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">

                    <v-card class="pa-0">
                        <v-app-bar color="green darken-2" dark flat dense>
                            <v-app-bar-title>Create Coupon</v-app-bar-title>
                            <!-- <v-spacer/>
                            <v-btn icon @click="createNewItemDialog = true">
                                <font-awesome-icon :icon="['fas', 'plus']" style="font-size: 20px;" fixed-width></font-awesome-icon>
                            </v-btn> -->
                        </v-app-bar>

                        <v-card-text>
                            <p>Let's start with the coupon's label, description, and type. You'll be able to change these and create the coupon code later.</p>
                            <!-- <v-btn style="background-color: green darken-2; color: #ffffff;" elevation="2" @click="createNewItemDialog = true">
                                Create
                            </v-btn> -->
                        </v-card-text>

                        <v-form @submit.prevent="createItem" @keyup.enter.native.prevent="createItem" class="px-2">
                            <!-- <v-select v-model="newCouponType" :items="couponTypeChoices" label="Coupon type"/> -->
                            <v-text-field v-model="newCouponLabel" label="Coupon label" hint="This will be displayed to customers." ref="newCouponLabelInput" outlined dense></v-text-field>
                            <v-textarea v-model="newCouponDescription" label="Coupon description" hint="This will be displayed to customers." ref="newCouponDescriptionInput" outlined dense></v-textarea>
                            <!-- <v-text-field v-model="newCouponAlias" label="Customer input" hint="What customers type to apply the coupon, like SPRING20" ref="newCouponAliasInput" outlined dense></v-text-field> -->
                            <!-- <v-checkbox v-model="newCouponRequireCode" label="Requires unique code" hint="A single coupon code distributed via individual codes." ref="newCouponRequireCodeInput" outlined dense></v-checkbox> -->
                            <p class="mb-0">What kind of coupon is it?</p>
                            <v-list v-if="couponTypeChoices.length > 0">
                                <v-list-item-group v-model="newCouponTypeIndex" color="green darken-2">
                                <v-list-item v-for="(item, idx) in couponTypeChoices" :key="idx">
                                    <v-list-item-icon>
                                        <font-awesome-icon :icon="item.icon" fixed-width></font-awesome-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ item.text }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            {{ item.description }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                </v-list-item-group>
                            </v-list>

                        </v-form>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn elevation="4" class="green white--text" @click="createItem" :disabled="!isNewItemFormComplete">
                                <span>Create</span>
                            </v-btn>
                            <!-- <v-btn text color="grey" @click="createNewItemDialog = false">
                                <span>Cancel</span>
                            </v-btn> -->
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped>

</style>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        organization: null,

        submitFormTimestamp: null,

        // newCouponAlias: null,
        newCouponLabel: null,
        newCouponDescription: null,
        // newCouponUniqueCode: false, // when false, a single code like 'SUMMER50' enables customers to apply the coupon; when true, customers require a unique code like 'A582-7C6B'
        newCouponTypeIndex: null,
    }),
    computed: {
        ...mapState({
            session: (state) => state.session,
            couponTypeChoices: (state) => state.couponTypeChoices,
        }),
        isNewItemFormComplete() {
            return typeof this.newCouponLabel === 'string' && this.newCouponLabel.length > 0
            && typeof this.newCouponDescription === 'string' && this.newCouponDescription.length > 0
            && typeof this.newCouponType === 'string' && this.newCouponType.length > 0;
        },
        newCouponType() {
            if (!Number.isInteger(this.newCouponTypeIndex) || !Array.isArray(this.couponTypeChoices)) {
                return null;
            }
            if (this.newCouponTypeIndex < 0 || this.newCouponTypeIndex >= this.couponTypeChoices.length) {
                return null;
            }
            return this.couponTypeChoices[this.newCouponTypeIndex].value;
        },
    },
    methods: {
        async loadOrganization() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadOrganization: true });
                const response = await this.$client.organization(this.$route.params.organizationId).currentOrganization.get();
                console.log(`organization/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.organization = response;
                } else {
                    // TODO: redirect back to organization list? show a not found message?
                }
            } catch (err) {
                console.error('failed to load organization', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadOrganization: false });
            }
        },
        async createItem() {
            if (Number.isInteger(this.submitFormTimestamp) && this.submitFormTimestamp + 500 > Date.now()) {
                return;
            }
            this.submitFormTimestamp = Date.now();
            try {
                this.$store.commit('loading', { createItem: true });
                const item = {
                    label: this.newCouponLabel,
                    description: this.newCouponDescription,
                    type: this.newCouponType,
                };
                const response = await this.$client.organization(this.$route.params.organizationId).coupon.create(item);
                if (response?.isCreated && response.id) {
                    this.$bus.$emit('snackbar', { type: 'success', headline: 'OK' });
                    this.$router.replace({ name: 'organization-edit-coupon', params: { organizationId: this.$route.params.organizationId }, query: { id: response.id, t: Date.now() } });
                } else {
                    this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed' });
                }
            } catch (err) {
                console.error('createItem failed', err);
                this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed' });
            } finally {
                this.$store.commit('loading', { createItem: false });
            }
        },
    },
    mounted() {
        this.loadOrganization();
        this.$nextTick(() => {
            setTimeout(() => { this.$activateInput('newCouponLabelInput'); }, 1);
        });
    },
};
</script>
